import { GET_ORDER_CHARGES } from '../actionTypes/CartActionTypes';

export default function OrderChargesReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_CHARGES:
            return action.payload;
        default:
            return state;
    }
}
